import { render, staticRenderFns } from "./PointOrderDetails.vue?vue&type=template&id=25f59a5d&scoped=true"
import script from "./PointOrderDetails.vue?vue&type=script&lang=js"
export * from "./PointOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./PointOrderDetails.vue?vue&type=style&index=0&id=25f59a5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f59a5d",
  null
  
)

export default component.exports